import { render } from "./ReportGetter.vue?vue&type=template&id=6d344bd9&scoped=true"
import script from "./ReportGetter.vue?vue&type=script&lang=js"
export * from "./ReportGetter.vue?vue&type=script&lang=js"

import "./ReportGetter.vue?vue&type=style&index=0&id=6d344bd9&lang=scss&scoped=true"
import "./ReportGetter.vue?vue&type=style&index=1&id=6d344bd9&lang=scss"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d344bd9"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner});
